module.exports = __webpack_public_path__ + "img/carshare_on.bed88b91.svg";